<div [innerHtml]="cmsContent" class="text-fixed-medium"></div>
